module.exports = __webpack_public_path__ + "img/giao_tai_cs.40307e00.png";